import React, { forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//horizontalScroll
import ScrollContainer from 'react-indiana-drag-scroll';
//select
import SelectSearch from 'react-select-search';
import 'src/asset/scss/plugin/select.scss';
//styles
import styles from 'src/asset/scss/styles/userPartnerItemReg.module.scss';
//hooks
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useAdminStore from 'src/webapp/stores/admin.store';
import useComnStore from 'src/webapp/stores/comn.store';
//CompWrapper
import Element from 'src/webapp/views/wrapper/Element';
import FormWrapper from 'src/webapp/views/wrapper/form/Form';//입력폼
import TitleWrapper from 'src/webapp/views/wrapper/form/Title';//입력폼내제목
//comp

export const Form = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({//상위컴포넌트에서 호출
        onSubmitHandler
    }));

    const onSubmitHandler = () => {
        couponRegAndUpdateAPI();
    }
    const { state } = useLocation();
    const FORM_CONFIG = [
        { label: '쿠폰 시퀀스', defaultValue: state?.SEQ_NO ?? '', inputMode: 'none', type: 'text' }
        , { label: '쿠폰 코드', defaultValue: state?.COUPON_CD ?? '', inputMode: 'none', type: 'text' }
        , { label: '쿠폰 이름', defaultValue: state?.COUPON_NAME ?? '', inputMode: 'none', type: 'text' }
        , { label: '할인 타입', radioName: 'DISCOUNT_TYP', checked: ["R", "A"], defaultCheck: [state?.DISCOUNT_TYP === "R" ? true : false, state?.DISCOUNT_TYP === "A" ? true : false], content: ['비율', '정액'], radioId: ['discount_value-1', 'discount_value-2'] }
        , { label: '쿠폰 발급 유형', radioName: 'ISSUE_TYP', checked: ["A", "M", "D"], defaultCheck: [state?.ISSUE_TYP === "A" ? true : false, state?.ISSUE_TYP === "M" ? true : false, state?.ISSUE_TYP === "D" ? true : false], content: ['전회원', '개별발급', '다운로드'], radioId: ['issue_type-1', 'issue_type-2', 'issue_type-3'] }
        , { label: '중복 할인 가능 여부', radioName: 'IS_STACKABLE', checked: ["Y", "N"], defaultCheck: [state?.IS_STACKABLE === "Y" ? true : false, state?.IS_STACKABLE === "N" ? true : false], content: ['가능', '불가능'], radioId: ['is_stackable-1', 'is_stackable-2'] }
        , { label: '할인 값 - 비율%, 금액', defaultValue: state?.DISCOUNT_VALUE ?? '', inputMode: 'none', type: 'text' }
        , { label: '비율 할인 시 최대 할인 금액', defaultValue: state?.MAX_DISCOUNT ?? '', inputMode: 'none', type: 'text' }
        , { label: '쿠폰 사용 최소 주문 금액', defaultValue: state?.MIN_ORDER_PRICE ?? '', inputMode: 'none', type: 'text' }
        , { label: '발급 가능 수량 - 0이면 무제한', defaultValue: state?.TOTAL_QUANTITY ?? '', inputMode: 'none', type: 'text' }
        , { label: '유저 1명당 최대 사용 가능 횟수', defaultValue: state?.MAX_USE_PER_USER ?? '', inputMode: 'none', type: 'text' }
    ];
    const navigator = useNavigate();
    const inputRef = useRef([]);//입력값
    //hook
    const { axiosPostHandler } = useAxiosHook();
    const { onNumberCommaHandler, onNumberHandler, removeCommaHandler, debounce } = useComnHook();
    //store
    const { admin } = useAdminStore();
    const { setMessage } = useComnStore();
    /* ============================ 입력값 ============================ */
    const now = new Date();//오늘자
    const sevendaysAfter = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);//7일후
    /* =============== 가입일 =============== */
    const [startDate, setStartDate] = useState(state?.START_DT ? new Date(state.START_DT.split(".")[0]) : now);
    const [endDate, setEndDate] = useState(state?.END_DT ? new Date("20" + state.END_DT.split(" ")[0]) : sevendaysAfter);
    const dateFormmat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year + '-' + month + '-' + day}`;
    }
    /* ==================== 옵션 ==================== */
    const [optionData, setOptionData] = useState({ type: [{ name: "상품", value: "P" }, { name: "카테고리", value: "C" }, { name: "브랜드", value: "B" }], active: null, selectOption: { P: { checked: false, value: null }, C: { checked: false, value: null }, B: { checked: false, value: null } }, selectKey: null, selectBrand: null });
    const debouncedSetPValue = useRef(
        debounce((value) => {
            setOptionData(prev => ({
                ...prev,
                selectOption: {
                    ...prev.selectOption,
                    P: {
                        ...prev.selectOption.P,
                        value: value
                    }
                }
            }));
        }, 300)
    ).current;
    const [option, setOption] = useState({ category_1: [], category_2: [], category_3: [], });//옵션State
    /*  옵션카테고리  */
    const siteCategoryTreeListAPI = async (value, position) => {
        const DATA = { PARENT_CATEGORY: value, DEPT_POSITION: position, STATE: 1 };
        const result = await axiosPostHandler("siteCategoryTreeListForAdmin.do", DATA);
        const isOk = result && result.message === "SUCCESS";
        if (!isOk) { return; }
        switch (position) {
            case 1: setOption(prev => ({ ...prev, category_1: result.data })); break;
            case 2: setOption(prev => ({ ...prev, category_2: result.data })); break;
            case 3: setOption(prev => ({ ...prev, category_3: result.data }));
        }
    }
    //초기 카테고리1 불러오기
    useEffect(() => {
        if (option.category_1.length > 0 || !optionData.selectOption.C.checked) { return; }
        siteCategoryTreeListAPI(0, 1);
    }, [optionData])
    /*  옵션브랜드  */
    /* ====================== 파트너코드 ====================== */
    const [partnerList, setPartnerList] = useState(null);
    const partnerListAPI = async (value) => {//0:무한로드, 1:검색 
        try {
            const DATA = { ROWNUM: 20, PARTNER_NAME: value, STATE: '' };
            const result = await axiosPostHandler(`partnerMasterListForAdmin.do`, DATA);
            const isOk = result && result.message === "SUCCESS";
            if (!isOk) { return; }
            setPartnerList(result.data);
        } finally { isLock.current = false; }
    }
    const debouncedHandler = useRef(debounce(partnerListAPI, 300));
    useEffect(() => {
        if (optionData.selectOption.B.checked) { return; }
        setPartnerList(null);
        if (optionData.selectBrand === null) { return; }
        setOptionData(prev => ({ ...prev, selectBrand: null }));
    }, [optionData])
    /* ====================== 파트너코드 ====================== */

    /* ==================== 옵션 ==================== */
    /* ==================== validationCheck ==================== */
    const makeRow = () => ({ id: crypto.randomUUID() });//추가옵션 객체 key값용 난수 생성
    const getRadioValue = (groupIndex) => {
        return (inputRef.current[groupIndex] || []).find(el => el?.checked)?.value;
    }
    const [discountType, setDiscountType] = useState(state?.DISCOUNT_TYP ?? null);
    //옵션조건함수
    const validateOption = () => {
        const OPTION_TYPES = ["P", "C", "B"];
        if (!optionData.active) return true; // 옵션 미사용이면 항상 OK
        const checkedTypes = OPTION_TYPES.filter(t => optionData.selectOption?.[t]?.checked);
        // active인데 아무것도 체크 안 했으면 invalid
        if (checkedTypes.length === 0) return false;
        // 체크된 것 중 value가 null/undefined/""면 invalid
        for (const t of checkedTypes) {
            const v = optionData.selectOption?.[t]?.value;
            if (v === null || v === undefined || v === "") return false;
        }

        return true;
    };
    //버튼검증
    const onValidateHandler = (index, value, e) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const normalizedStartDate = new Date(startDate);
        const normalizedEndDate = new Date(endDate);
        normalizedStartDate.setHours(0, 0, 0, 0);
        normalizedEndDate.setHours(0, 0, 0, 0);
        if (!validateOption()) { props.onValid(null, true); return; }
        switch (state?.TYPE) {
            case "ALREADY_ISSUED":
                if (today > normalizedEndDate) { props.onValid(null, true); return; }
                for (let i = 0; i < inputRef.current.length; i++) {
                    if (inputRef.current[i]?.value?.length <= 0) {
                        props.onValid(null, true); return;
                    }
                }
                break;
            case "USED": if (today > normalizedEndDate) { props.onValid(null, true); return; } break;
            default:
                if (index === 0) { e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'); }
                if (index === 3) { setDiscountType(value) }
                for (let i = 1; i < inputRef.current.length; i++) {
                    if (inputRef.current[i] === null) continue;
                    if ((i === 3 || i === 4 || i === 5) && getRadioValue(i) === undefined) { props.onValid(null, true); return; }
                    else { if (inputRef.current[i]?.value?.length <= 0) { props.onValid(null, true); return; } }
                }
                if (!state && normalizedStartDate < today) { props.onValid(null, true); return; }
                if ((endDate.getTime() - startDate.getTime()) <= 0) { props.onValid(null, true); return; }
        }
        props.onValid(null, false);
    }
    useEffect(() => {
        onValidateHandler();
    }, [startDate, endDate, discountType, optionData])
    /* ==================== validationCheck ==================== */
    /* ==================== 쿠폰등록및 수정API ==================== */
    const isLock = useRef(false);
    //TARGET_LIST 리퀘스트생성함수
    const buildTargetList = () => {
        if (!optionData.active) return [];

        const selectOption = optionData.selectOption || {};
        const types = ["P", "C", "B"];

        return types
            .filter(t => selectOption[t]?.checked)
            .map(t => ({
                TARGET_TYP: t,
                TARGET_KEY: selectOption[t]?.value,
            }));
    };
    const couponRegAndUpdateAPI = async () => {//type - 1.등록, 2.수정, 3.부분수정
        try {
            const type = state ? "수정" : "등록";
            if (isLock.current) { return; }
            if (!validateOption()) {
                setMessage({ type: 2, label: "옵션 설정을 확인해주세요." });
                return;
            }
            isLock.current = true;

            let DATA;
            switch (state?.TYPE) {
                case "ALREADY_ISSUED": DATA = { MASTER: { SEQ_NO: state?.SEQ_NO, COUPON_CD: inputRef.current[1]?.value ?? "", COUPON_NAME: inputRef.current[2]?.value ?? "", END_DT: dateFormmat(endDate).replaceAll("-", "") }, REG_INFO: { STATE: 3, ADMIN_ID: admin.COMN_ID } }; break;
                case "USED": DATA = { MASTER: { SEQ_NO: state?.SEQ_NO, END_DT: dateFormmat(endDate).replaceAll("-", "") }, REG_INFO: { STATE: 3, ADMIN_ID: admin.COMN_ID } }; break;
                default:
                    DATA = {
                        MASTER: {
                            SEQ_NO: inputRef.current[0]?.value.length > 0 ? inputRef.current[0]?.value : 0,
                            COUPON_CD: inputRef.current[1]?.value ?? "",
                            COUPON_NAME: inputRef.current[2]?.value ?? "",
                            DISCOUNT_TYP: getRadioValue(3) ?? "",
                            ISSUE_TYP: getRadioValue(4) ?? "",
                            IS_STACKABLE: getRadioValue(5) ?? "",
                            DISCOUNT_VALUE: removeCommaHandler(inputRef.current[6]?.value ?? ""),
                            MAX_DISCOUNT: removeCommaHandler(inputRef.current[7]?.value ?? ""),
                            MIN_ORDER_PRICE: removeCommaHandler(inputRef.current[8]?.value ?? ""),
                            TOTAL_QUANTITY: removeCommaHandler(inputRef.current[9]?.value ?? ""),
                            MAX_USE_PER_USER: removeCommaHandler(inputRef.current[10]?.value ?? ""),
                            START_DT: dateFormmat(startDate).replaceAll("-", ""),
                            END_DT: dateFormmat(endDate).replaceAll("-", ""),
                        },
                        TARGET_LIST: buildTargetList(),
                        REG_INFO: {
                            STATE: state ? 2 : 1,
                            ADMIN_ID: admin.COMN_ID
                        }
                    };
            }
            const result = await axiosPostHandler("siteCouponUpsertForAdmin.do", DATA);
            const isOk = result && result.message === "SUCCESS";
            if (isOk) { setMessage({ type: 1, label: `쿠폰 ${type}이 완료되었습니다.` }); navigator(-1, { replace: true }); return; }
            setMessage({ type: 2, label: `쿠폰 ${type}에 실패 하였습니다.` });

        } finally { isLock.current = false; }
    }
    /* ==================== 쿠폰등록및 수정API ==================== */
    /* ==================== 옵션체크 ==================== */
    const onCheckedHandler = (type, checked) => {
        setOptionData(prev => ({ ...prev, selectOption: { ...prev.selectOption, [type]: { ...prev.selectOption[type], checked: checked, value: checked ? prev.selectOption[type].value : null } } }))
    }
    /* ==================== 옵션체크 ==================== */
    /* ==================== 수정페이지 초기값세팅 ==================== */
    useEffect(() => {
        if (!state?.TARGET_LIST) return;

        const list = state.TARGET_LIST;

        // TARGET_LIST 없으면 옵션 미사용
        if (!Array.isArray(list) || list.length === 0) {
            setOptionData(prev => ({ ...prev, active: false }));
            return;
        }

        // 기본 구조 복사
        const newSelectOption = { ...optionData.selectOption };
        let newSelectBrand = null;

        list.forEach(item => {
            const { TARGET_TYP, TARGET_KEY } = item;

            if (!newSelectOption[TARGET_TYP]) return;

            // value 세팅 + 체크 활성화
            newSelectOption[TARGET_TYP] = {
                checked: true,
                value: TARGET_KEY
            };

            // 브랜드일 경우 selectBrand도 같이 세팅
            if (TARGET_TYP === "B") {
                newSelectBrand = { PARTNER_NAME: TARGET_KEY };
            }
        });

        setOptionData(prev => ({
            ...prev,
            active: true,
            selectOption: newSelectOption,
            selectBrand: newSelectBrand
        }));

    }, [state]);
    /* ==================== 수정페이지 초기값세팅 ==================== */

    return (
        <>
            <Element tag={`div`} className={styles.formArea}>
                {/* START 입력필드 */}
                {/* 제품명 ~ 작업시간 */}
                {state?.TYPE !== "USED" && [...Array(state?.TYPE === "ALREADY_ISSUED" ? 2 : 3)].map((x, i) =>
                    <FormWrapper key={i}>
                        <TitleWrapper title={FORM_CONFIG[state?.TYPE === "ALREADY_ISSUED" ? i + 1 : i].label} />
                        <input type={FORM_CONFIG[state?.TYPE === "ALREADY_ISSUED" ? i + 1 : i].type} inputMode={FORM_CONFIG[state?.TYPE === "ALREADY_ISSUED" ? i + 1 : i].inputMode}
                            defaultValue={FORM_CONFIG[state?.TYPE === "ALREADY_ISSUED" ? i + 1 : i].defaultValue}
                            onChange={(e) => { onValidateHandler(i, e.target.value, e); }}
                            ref={el => (inputRef.current[state?.TYPE === "ALREADY_ISSUED" ? i + 1 : i] = el)} />
                    </FormWrapper>
                )}
                {/* 옵션 */}
                {state?.TYPE !== "ALREADY_ISSUED" && state?.TYPE !== "USED" && <FormWrapper>
                    <TitleWrapper title={"옵션 설정"} />
                    <div className="radioArea"><div><input type="radio" name={"option_typ"} className="radio" id={"option_typ_2"} onChange={() => setOptionData(prev => ({ ...prev, active: true }))} checked={optionData.active ? true : false} />
                        <label htmlFor={"option_typ_2"} className="radio-label" >사용</label></div></div>
                    <div className="radioArea"><div><input type="radio" name={"option_typ"} className="radio" id={"option_typ_3"} onChange={() => setOptionData(prev => ({ ...prev, active: false }))} checked={!optionData.active ? true : false} />
                        <label htmlFor={"option_typ_3"} className="radio-label" >미사용</label></div></div>
                </FormWrapper>}
                {state?.TYPE !== "ALREADY_ISSUED" && state?.TYPE !== "USED" && optionData.active &&
                    <FormWrapper>
                        <TitleWrapper title={"옵션선택"} />
                        {/* <div className="selectArea">
                            <SelectSearch options={optionData.type} onChange={(e) => setOptionData(prev => ({ ...prev, selectOption: e, selectKey: null, selectBrand: null }))} placeholder='--옵션선택--' />
                        </div> */}
                        <div className={styles.flexRow}>
                            <label>상품</label>
                            <input type='checkbox' checked={optionData.selectOption.P.checked ? true : false} onChange={(e) => onCheckedHandler("P", e.target.checked)} />
                            <label>카테고리</label>
                            <input type='checkbox' checked={optionData.selectOption.C.checked ? true : false} onChange={(e) => onCheckedHandler("C", e.target.checked)} />
                            <label>브랜드</label>
                            <input type='checkbox' checked={optionData.selectOption.B.checked ? true : false} onChange={(e) => onCheckedHandler("B", e.target.checked)} />
                        </div>
                    </FormWrapper>}
                {state?.TYPE !== "ALREADY_ISSUED" && state?.TYPE !== "USED" && optionData.selectOption.C.checked === true ? <div className={styles.flexRow}>
                    <FormWrapper>
                        <TitleWrapper title={"카테고리코드1"} />
                        <div className="selectArea">
                            <SelectSearch options={option.category_1} placeholder="--옵션선택--" onChange={(e) => siteCategoryTreeListAPI(e, 2)} />
                        </div>
                    </FormWrapper>
                    <FormWrapper>
                        <TitleWrapper title={"카테고리코드2"} />
                        <div className="selectArea">
                            <SelectSearch options={option.category_2} placeholder="--옵션선택--" onChange={(e) => siteCategoryTreeListAPI(e, 3)} />
                        </div>
                    </FormWrapper>
                    <FormWrapper>
                        <TitleWrapper title={"카테고리코드3"} />
                        <div className="selectArea">
                            <SelectSearch options={option.category_3} placeholder="--옵션선택--" onChange={(e) => setOptionData(prev => ({ ...prev, selectOption: { ...prev.selectOption, C: { ...prev.selectOption.C, value: e } } }))} />
                        </div>
                    </FormWrapper>
                </div> : null}
                {state?.TYPE !== "ALREADY_ISSUED" && state?.TYPE !== "USED" && optionData.selectOption.B.checked === true ?
                    <>
                        <FormWrapper>
                            <TitleWrapper title={"판매자검색"} />
                            <input type={"text"} onChange={(e) => debouncedHandler.current(e.target.value)} />
                            {partnerList?.length > 0 ?
                                <div>
                                    <button onClick={(e) => setPartnerList(null)}>닫기</button>
                                    <ul>
                                        {partnerList.map((item) =>
                                            <li key={item.PARTNER_CD} onClick={(e) => setOptionData(prev => ({ ...prev, selectOption: { ...prev.selectOption, B: { ...prev.selectOption.B, value: item.PARTNER_NAME } }, selectBrand: item }))}><span>{item.PARTNER_NAME}</span></li>
                                        )}
                                    </ul>
                                </div>
                                : null}
                        </FormWrapper>
                        <FormWrapper>
                            <div className={styles.listArea}>
                                <ScrollContainer horizontal={true} component={`ul`}>
                                    {optionData.selectBrand !== null && <li onClick={(e) => setOptionData(prev => ({ ...prev, selectOption: { ...prev.selectOption, B: { ...prev.selectOption.B, value: null } }, selectBrand: null }))}><span>{optionData.selectBrand.PARTNER_NAME}</span><button><FontAwesomeIcon icon="fa-light fa-xmark" /></button></li>}
                                </ScrollContainer>
                            </div>
                        </FormWrapper>
                    </> : null}
                {state?.TYPE !== "ALREADY_ISSUED" && state?.TYPE !== "USED" && optionData.selectOption.P.checked === true ?
                    <>
                        <FormWrapper>
                            <TitleWrapper title={"상품코드"} />
                            <input type={"text"} onChange={(e) => {debouncedSetPValue(e.target.value); onNumberHandler(e);}} />
                        </FormWrapper>
                    </> : null}
                {state?.TYPE !== "ALREADY_ISSUED" && state?.TYPE !== "USED" && [...Array(3)].map((x, i) =>
                    <FormWrapper>
                        <TitleWrapper title={FORM_CONFIG[i + 3].label} />
                        {[...Array(FORM_CONFIG[i + 3].radioId.length)].map((x, idx) =>
                            <div><input type="radio" name={FORM_CONFIG[i + 3].radioName} className="radio" value={FORM_CONFIG[i + 3].checked[idx]}
                                id={FORM_CONFIG[i + 3].radioId[idx]} ref={(el) => { if (!inputRef.current[i + 3]) inputRef.current[i + 3] = []; inputRef.current[i + 3][idx] = el; }}
                                onChange={(e) => { onValidateHandler(i + 3, FORM_CONFIG[i + 3].checked[idx], e); }} defaultChecked={FORM_CONFIG[i + 3].defaultCheck[idx]} />
                                <label htmlFor={FORM_CONFIG[i + 3].radioId[idx]} className="radio-label" >{FORM_CONFIG[i + 3].content[idx]}</label></div>)}
                    </FormWrapper>
                )}
                {state?.TYPE !== "ALREADY_ISSUED" && state?.TYPE !== "USED" && <FormWrapper>
                    <TitleWrapper title={'쿠폰 사용 시작 일시'} />
                    <input onChange={(e) => setStartDate(new Date(e.target.value))} type="date" placeholder={'선택하세요'} value={startDate === null ? now : dateFormmat(startDate)} />
                </FormWrapper>}
                <FormWrapper>
                    <TitleWrapper title={'쿠폰 사용 종료 일시'} />
                    <input onChange={(e) => setEndDate(new Date(e.target.value))} type="date" placeholder={'선택하세요'} value={endDate === null ? now : dateFormmat(endDate)} />
                </FormWrapper>
                {state?.TYPE !== "ALREADY_ISSUED" && state?.TYPE !== "USED" && [...Array(5)].map((x, i) => {
                    return (
                        i === 1 && discountType !== "R" ? null :
                            <FormWrapper key={i}>
                                <TitleWrapper title={FORM_CONFIG[i + 6].label} />
                                <input type={FORM_CONFIG[i + 6].type} inputMode={FORM_CONFIG[i + 6].inputMode}
                                    defaultValue={FORM_CONFIG[i + 6].defaultValue}
                                    onChange={(e) => { onValidateHandler(i + 6, e.target.value, e); onNumberCommaHandler(e); }}
                                    ref={el => (inputRef.current[i + 6] = el)} />
                            </FormWrapper>)
                }
                )}
            </Element>
        </>
    );
})
export default Form;